import {validateName} from './nameValidation';

const normalizeName = (name: string) => name.trim().toLowerCase();

export const validateCatalogName = (name: string, existingNames: readonly string[] = [], originalName?: string): 'too_short' | 'duplicate' | undefined => {
    const normalized = normalizeName(name);
    if (validateName(name)) return 'too_short';
    if (originalName !== undefined && normalized === normalizeName(originalName)) return undefined;
    return existingNames.some(existing => normalizeName(existing) === normalized) ? 'duplicate' : undefined;
};
